import React, { useState } from "react";
import { Container, Segment } from "semantic-ui-react";
import { toast } from "react-toastify";
import { useStore } from "../../../stores/store";
import PreSurveyHomePage from "./1homePage";
import PreSurveyIntroductionPage from "./2introductionPage";
import PreSurveySelfReflectionPage from "./3selfReflectionPage";
import PreSurveyAboutMePage from "./4aboutMePage";

interface Props {
  surveyCode: string;
  onStartSurvey: () => void;
}

export default function InitiateSurveyUz({ surveyCode, onStartSurvey }: Props) {
  const { commonStore } = useStore();

  const handleError = (error: any) =>
    toast.error(
      "An error has occurred while processing your request. Please try again or contact your system admin"
    );

  const submitForm = () => {
    if (commonStore.currentUserSurveyId === 0) {
      toast.warn("Initiating survey, please try again");
      return;
    }
    onStartSurvey();
  };

  const [currentPage, setCurrentPage] = useState<number>(0);
  let content = (
    <>
      <Container className="survey-intro lpoasis-survey">
        <Segment className="survey-intro-content">
          {currentPage === 0 && (
            <PreSurveyHomePage
              onNavigateNext={() => {
                setCurrentPage(currentPage + 1);
              }}
            />
          )}

          {currentPage === 1 && (
            <PreSurveyIntroductionPage
              onNavigateNext={() => {
                setCurrentPage(currentPage + 1);
              }}
              onNavigatePrevious={() => {
                setCurrentPage(currentPage - 1);
              }}
            />
          )}

          {currentPage === 2 && (
            <PreSurveyAboutMePage
              onNavigateNext={() => {
                submitForm();
              }}
              onNavigatePrevious={() => {
                setCurrentPage(currentPage - 1);
              }}
            />
          )}
        </Segment>
      </Container>
    </>
  );

  return <>{surveyCode && content}</>;
}
